import { ethereum } from '@0xtorch/core'
import { optimism } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createOptimismChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}) =>
  createOptimismChainCustom({
    client: createClient({
      chain: optimism,
      httpRpcs: optimismHttpRpcs,
    }),
    explorer: createEtherscanV2({
      name: 'OP Mainnet Explorer',
      baseUrl: 'https://optimistic.etherscan.io',
      chainId: 10,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateOptimismChainParameters = {
  client: Client
  explorer: Explorer
}

export const createOptimismChainCustom = ({
  client,
  explorer,
}: CreateOptimismChainParameters): Chain => ({
  id: 10,
  network: 'optimism',
  name: 'Optimism',
  nativeToken: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    currency: ethereum,
  },
  wrappedTokenAddresses: new Set([
    '0x4200000000000000000000000000000000000006',
  ]),
  explorer,
  client,
  blockTime: 2000,
  coingeckoId: 'optimistic-ethereum',
  defillamaId: 'optimism',
})

export const optimismHttpRpcs: HttpRpc[] = [
  {
    url: 'https://mainnet.optimism.io/',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://1rpc.io/op',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
  // Not archiving receipts
  // {
  //   url: 'https://op-pokt.nodies.app',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 40_000n,
  // },
  {
    url: 'https://opt-mainnet.g.alchemy.com/v2/demo',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://optimism.public.blockpi.network/v1/rpc/public',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1024n,
  },
  // Not archiving receipts
  // {
  //   url: 'https://endpoints.omniatech.io/v1/op/mainnet/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 3000n,
  // },
  {
    url: 'https://optimism-rpc.publicnode.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 2000n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://rpc.optimism.gateway.fm',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 4000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://optimism-rpc.publicnode.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://optimism.meowrpc.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Endpoint is not working
  // {
  //   url: 'https://api.zan.top/node/v1/opt/mainnet/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://optimism.publicnode.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://optimism.meowrpc.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://optimism.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 20_000n,
  },
  {
    url: 'https://optimism.gateway.tenderly.co',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 40_000n,
  },
  {
    url: 'https://gateway.tenderly.co/public/optimism',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 40_000n,
  },
  // Not archiving receipts
  // {
  //   url: 'https://api.stateless.solutions/optimism/v1/demo',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Endpoint is not working
  // {
  //   url: 'https://public.stackup.sh/api/v1/node/optimism-mainnet',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Endpoint is not working
  // {
  //   url: 'https://optimism-mainnet.gateway.tatum.io',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://optimism.rpc.subquery.network/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
]

export const optimismWebsocketRpcUrls: readonly string[] = [
  'wss://optimism.publicnode.com',
]
